/**
 * Theme initialization script
 * Extracted from inline script for better performance (deferred loading)
 */

(function() {
  // IE11 detection and polyfill
  if (window.navigator.userAgent.indexOf('MSIE ') > 0 || window.navigator.userAgent.indexOf('Trident/') > 0) {
    document.documentElement.className = document.documentElement.className + ' ie';

    var scripts = document.getElementsByTagName('script')[0];
    var polyfill = document.createElement("script");
    polyfill.defer = true;
    polyfill.src = window.themeAssets.ie11;

    scripts.parentNode.insertBefore(polyfill, scripts);
  } else {
    document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
  }

  // Scrollbar width calculation - cached to avoid forced reflows
  var cachedScrollbarWidth = null;
  function getScrollbarWidth() {
    if (cachedScrollbarWidth !== null) {
      return cachedScrollbarWidth;
    }
    var outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    outer.style.msOverflowStyle = 'scrollbar';
    document.documentElement.appendChild(outer);

    var inner = document.createElement('div');
    outer.appendChild(inner);

    cachedScrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    outer.parentNode.removeChild(outer);

    return cachedScrollbarWidth;
  }

  document.documentElement.style.setProperty('--scrollbar-width', getScrollbarWidth() + 'px');

  // Viewport height CSS variables
  var windowInnerHeight = window.innerHeight;
  document.documentElement.style.setProperty('--full-height', windowInnerHeight + 'px');
  document.documentElement.style.setProperty('--three-quarters', (windowInnerHeight * 0.75) + 'px');
  document.documentElement.style.setProperty('--two-thirds', (windowInnerHeight * 0.66) + 'px');
  document.documentElement.style.setProperty('--one-half', (windowInnerHeight * 0.5) + 'px');
  document.documentElement.style.setProperty('--one-third', (windowInnerHeight * 0.33) + 'px');
  document.documentElement.style.setProperty('--one-fifth', (windowInnerHeight * 0.2) + 'px');
})();
